<template>
  <div style="position:relative;">
    <el-container>
      <div style="width: 100%;">
        <div class="content">
          <div class="title">
            <img :src="blog.headPortraitUrl" class="round" width="35px" height="35px">
            <span style="margin-left: 6px;font-size: 16px;color: #409EFF;font-weight: bold">{{ blog.adminName }}</span>
            <div style="color: #9c9696">
              <i class="el-icon-date" style="margin-left: 25px;margin-top: 1px;"></i>
              <span style="margin-left: 3px;font-size: 14px">{{ blog.createTime }}</span>
              <i class="el-icon-view" style="margin-left: 10px;margin-top: 1px;"></i>
              <span style="margin-left: 3px;font-size: 14px">{{ blog.viewCount }}</span>
            </div>
            <div style="margin: 0 0 0 auto">
              <i class="el-icon-close" style="font-size: 35px;cursor: pointer" @click="goHome"></i>
            </div>
          </div>

          <div style="padding-right: 20px;padding-left: 20px;padding-bottom: 20px;">

            <!--表头区域        http://hikari.top/images/f600fa83-0f63-4b93-a638-bb4792512bc2.jpeg    -->
            <div style="display: flex;margin-top: 20px;align-items: center;background-color: rgba(255,255,255,0.86)">
              <img :src="blog.firstImage"
                   style="height: 400px;width: 400px;border-radius: 20px"/>
              <div style="margin: -40px -15px 0 auto;width: 380px">
                <div style="display: flex;align-items: center">
                  <img src="../assets/image/pingfen.png"
                       style="width: 50px;height: 50px"/>
                  <span style="font-size: 34px;margin-left: 10px;color: #F7BA2A">评分</span>
                </div>
                <div style="display: flex;margin-top: 5px;align-items: center;">
                  <span style="font-size: 52px;">{{ scorePercentage.scoreStatic * 2 }}</span>
                  <div style="display: flex;flex-flow: column;margin-left: 10px;align-items: center;">
                    <el-rate disabled v-model="scorePercentage.scoreStatic"></el-rate>
                    <span style="color: rgb(55,131,195);cursor: pointer">{{
                        scorePercentage.totalAccessCount
                      }}人评价</span>
                  </div>
                </div>

                <div>
                  <div style="display: flex;align-items: center;margin-top: 7px">
                    <span style="font-size: 20px">5星</span>
                    <div id="fiveStar"
                         style="height: 20px;background-color: rgb(255,213,150);margin-left: 10px"></div>
                    <span style="color: rgb(114,119,142);margin-left: 7px">{{ scorePercentage.fiveStar }}</span>
                  </div>
                  <div style="display: flex;align-items: center;margin-top: 4px">
                    <span style="font-size: 20px">4星</span>
                    <div id="fourStar"
                         style="height: 20px;background-color:rgb(255,213,150);margin-left: 10px"></div>
                    <span style="color: rgb(114,119,142);margin-left: 7px">{{ scorePercentage.fourStar }}</span>
                  </div>
                  <div style="display: flex;align-items: center;margin-top: 4px">
                    <span style="font-size: 20px">3星</span>
                    <div id="threeStar"
                         style="height: 20px;background-color: rgb(255,213,150);margin-left: 10px"></div>
                    <span style="color: rgb(114,119,142);margin-left: 7px">{{ scorePercentage.threeStar }}</span>
                  </div>
                  <div style="display: flex;align-items: center;margin-top: 4px">
                    <span style="font-size: 20px">2星</span>
                    <div id="twoStar"
                         style="height: 20px;background-color: rgb(255,213,150);margin-left: 10px"></div>
                    <span style="color: rgb(114,119,142);margin-left: 7px">{{ scorePercentage.twoStar }}</span>
                  </div>
                  <div style="display: flex;align-items: center;margin-top: 4px">
                    <span style="font-size: 20px">1星</span>
                    <div id="oneStar"
                         style="height: 20px;background-color: rgb(255,213,150);margin-left: 10px"></div>
                    <span style="color: rgb(114,119,142);margin-left: 7px">{{ scorePercentage.oneStar }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!--内容区-->
            <hr>
            <h1 align="center" style="font-size: 36px;">{{ blog.title }}</h1>
            <h2>介绍</h2>
            <p style="line-height: 25px;word-wrap: break-word;">{{ blog.introduction }}</p>
            <div style="word-wrap: break-word;">
              <div style="line-height: 25px;" class="markdown-body" v-html="blog.contentHtml"></div>
            </div>
          </div>
          <!--底部的区域-->
          <div
            style="background-color: #fcfff5;height: 120px;display: flex;margin-left: 3px;margin-right: 3px;border-radius: 10px;box-shadow: inset 0 0 0 1px #a3c293;">
            <ul>
              <li style="color:#2c662d;margin: 13px 0 0 0">作者 <span>{{ blog.adminName }}</span></li>
              <li style="color:#2c662d;margin: 15px 0 0 0 ">发表时间 <span>{{ blog.createTime }}</span></li>
            </ul>
            <div
              style="display: flex;margin: 0 60px 0 auto;flex-direction: column;justify-content: center;width: 150px">
              <span style="margin-left:20px;margin-bottom: 10px;color:#2c662d">给我评分吧</span>
              <el-rate
                v-model="userScore"
                :texts="texts"
                @change="scoreChange"
                :disabled="!isEdit"
                show-text>
              </el-rate>
            </div>
          </div>

          <!--          留言部分-->
          <el-card shadow="never" style="padding: 20px" class="comments">
            <div class="header">
              评论
            </div>
            <hr>
            <div v-for="item of Comment">
              <div v-if="item.deleted===0">
                <div style="display: flex;height: 30px">
                  <img :src="item.mainHeadPortrait" width="30px" height="30px">
                  <div style="display: flex;line-height: 30px;margin-left: 10px;"><b>{{ item.mainName }}</b></div>&nbsp;&nbsp;&nbsp;
                  <div style="display: flex;line-height: 30px"><font style="color: gray;font-size: 5px">{{
                      item.createTime
                    }}</font>
                  </div>
                </div>
                <div style="margin-left: 40px;width: 850px;margin-top: -10px">
                  <p>{{ item.content }}</p>
                  <div style="margin-left: -40px;width: 850px;margin-top: -10px">
                    <span class="reply" @click="big(item.id)">回复</span>
                    <span v-if="isLogin">
                      <span v-if="item.userId===userId">
                      <span class="delete" @click="del(item.id,0)">删除</span>
                      </span>
                    </span>
                    <span v-if="BigActiveId===item.id">
                      <el-form :model="ruleForm" status-icon :rules="rules" :ref="'ruleForm2'+item.id" class="commet-reply">
                          <el-form-item prop="content">
                            <el-input style="color: red"
                                      type="textarea"
                                      :rows="1"
                                      placeholder="请输入你的回复"
                                      v-model="ruleForm.checkText">
                            </el-input>
                          </el-form-item>
                      <div style="margin: 20px 0;"></div>
                          <el-form-item style="text-align: right;margin-bottom: -20px;margin-top: -15px">
                            <el-button @click="BigActiveId=-1" type="primary" size="small">取消</el-button>
                            <el-button @click="reply(item.replyId,item.userId,userId,item.userId,'ruleForm2'+item.id)" type="primary"
                                       size="small">确认</el-button>
                          </el-form-item>
                      </el-form>
                    </span>
                  </div>
                  <!--回复内容-->
                  <div v-if="item.articleUser">
                    <div v-if="item.articleUser.length>0">
                      <div v-for="ite of item.articleUser">
                        <div v-if="ite.mainId!=='null'">
                          <el-divider></el-divider>
                          <div style="display: flex;height: 30px">
                            <img :src="ite.headPortrait1" width="30px" height="30px">
                            <div style="display: flex;line-height: 30px;margin-left: 10px;"><b>{{ ite.name1 }}<font
                              color="red"> 回复 </font>{{ ite.name2 }}</b>
                            </div>&nbsp;&nbsp;&nbsp;
                            <div style="display: flex;line-height: 30px"><font
                              style="color: gray;font-size: 5px">{{ ite.replyTime }}</font>
                            </div>
                          </div>
                          <div style="margin-left: 40px;width: 850px;margin-top: -10px">
                            <p>{{ ite.replyContent }}</p>
                            <div style="margin-left: -40px;width: 850px;margin-top: -10px">
                              <span class="reply" @click="small(ite.uuId)">回复</span>
                              <span v-if="isLogin">
                                <span v-if="ite.id1===userId">
                                  <span class="delete" @click="del(ite.uuId,1)">删除</span>
                                </span>
                              </span>
                              <span v-if="SmallActiveId===ite.uuId">
                                <el-form :model="ruleForm" status-icon :rules="rules" :ref="'ruleForm1'+ite.id"
                                         class="commet-reply">
                                  <el-form-item prop="content">
                                    <el-input style="color: red"
                                              type="textarea"
                                              :rows="1"
                                              placeholder="请输入你的留言"
                                              v-model="ruleForm.checkText">
                                    </el-input>
                                  </el-form-item>
                                <div style="margin: 20px 0;"></div>
                                  <el-form-item style="text-align: right;margin-bottom: -20px;margin-top: -15px">
                                    <el-button @click="SmallActiveId=-1" type="primary" size="small">取消</el-button>
                                    <el-button @click="reply(item.replyId,item.userId,userId,ite.id1,'ruleForm1'+ite.id)"
                                               type="primary"
                                               size="small">确认</el-button>
                                  </el-form-item>
                                </el-form>
                              </span>
                            </div>
                            <el-divider></el-divider>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else></div>
                  </div>
                </div>
                <el-divider></el-divider>
              </div>
            </div>

            <div>
              <div class="fewbody" style="background-color: transparent;border: none;margin-bottom: 30px">
                <el-pagination @current-change="change" style="text-align: left"
                               background
                               :page-size="5"
                               :current-page.sync="currentPage"
                               :hide-on-single-page="true"
                               layout="prev, pager, next"
                               :total="totalCount">
                </el-pagination>
              </div>
            </div>

            <el-form :model="ruleForm" status-icon :rules="bigRules" ref="ruleForm" class="commet-reply">
              <el-form-item prop="content">
                <el-input style="color: red"
                          type="textarea"
                          :rows="5"
                          placeholder="请输入你的留言"
                          v-model="ruleForm.content">
                </el-input>
              </el-form-item>
              <div style="margin: 20px 0;"></div>
              <el-form-item style="text-align: right">
                <el-button @click="send('ruleForm')" type="primary">点击发表</el-button>
              </el-form-item>
            </el-form>
          </el-card>


        </div>
      </div>
    </el-container>
  </div>
</template>

<script>

import request from "../utils/axiosUtils";
import base_url from "../utils/Constants";

export default {
  name: "ArticleContent",
  data() {
    var validatePass = (rule, value, callback) => {
      if (this.ruleForm.checkText === "") {
        callback(new Error('留言内容不能为空！'));
      } else if (this.ruleForm.checkText.length > 100) {
        return callback(new Error('留言内容不超过100字！'))
      }
      callback();
    };
    var checkPass = (rule, value, callback) => {
      if (this.ruleForm.content === "") {
        callback(new Error('留言内容不能为空！'));
      } else if (this.ruleForm.content.length > 100) {
        return callback(new Error('留言内容不超过100字！'))
      }
      callback();
    };
    return {
      //BaseUrl
      base_url: base_url,

      isLogin: false,
      //用户编号
      userId: '',
      //博客编号
      blogId: '',
      scorePercentage: {
        scoreStatic: null,
        totalAccessCount: '',
        oneStar: '',
        twoStar: '',
        threeStar: '',
        fourStar: '',
        fiveStar: ''
      },
      //用户评分
      userScore: 0,
      //用户是否还可以编辑
      isEdit: true,
      texts: ['很差', '较差', '还行', '好', '很好'],
      blog: {},

      //评论内容
      ruleForm: {
        checkText: '',
        content: ''
      },
      rules: {
        content: [
          {validator: validatePass, trigger: 'blur'}
        ]
      },
      bigRules: {
        content: [
          {validator: checkPass, trigger: 'blur'}
        ]
      },
      Comment: {
        id: '',
        mainName: '',
        mainHeadPortrait: '',
        userId: '',
        articleId: '',
        content: '',
        deleted: '',
        replyId: '',
        createTime: '',
        updateTime: '',
        articleUser: {
          isreplyId: '',
          mainId: '',
          uuId: '',
          replyContent: '',
          replyTime: '',
          isDeleted: '',
          id1: '',
          name1: '',
          headPortrait1: '',
          id2: '',
          name2: '',
          headPortrait2: ''
        }
      },
      BigActiveId: -1,
      SmallActiveId: -1,
      input: '',
      currentPage: 1,
      totalCount: null,
    }
  },
  methods: {
    //返回首页
    goHome() {
      this.$router.push({
        path: '/home',
      })
    },
    //处理时间
    handleTime(date) {
      let time = new Date(
        date.substr(0, 4),
        parseInt(date.substr(5, 2)) - 1,
        date.substr(8, 2),
        date.substr(11, 2),
        date.substr(14, 2),
        date.substr(17, 2),
      );
      let year = time.getFullYear();
      let month = this.handleZero(time.getMonth() + 1);
      let day = this.handleZero(time.getDate());
      return year + "-" + month + "-" + day;
    },
    handleZero(time) {
      if (time < 10) {
        return '0' + time;
      } else {
        return time
      }
    },
    //获取博客内容
    getBlogById() {
      request({
        url: '/blog/getBlog/' + this.blogId,
        method: 'get',
      }).then(response => {
        // console.log(response)
        let data = response.data.data;
        data.createTime = this.handleTime(data.createTime);
        data.firstImage = base_url + "/getImage/" + data.firstImage
        data.headPortraitUrl = base_url + "/getImage/" + data.headPortraitUrl
        this.blog = data;

        let oneStar = response.data.data.oneStar;
        let twoStar = response.data.data.twoStar;
        let threeStar = response.data.data.threeStar;
        let fourStar = response.data.data.fourStar;
        let fiveStar = response.data.data.fiveStar;
        if (oneStar === 0 && twoStar === 0 && threeStar === 0 && fourStar === 0 && fiveStar === 0) {
          this.scorePercentage.scoreStatic = 0;
          this.scorePercentage.totalAccessCount = 0;
          return;
        }
        let totalAccessCount = oneStar + twoStar + threeStar + fourStar + fiveStar;
        this.scorePercentage.totalAccessCount = totalAccessCount;
        this.scorePercentage.oneStar = (oneStar / totalAccessCount * 100).toFixed(1) + "%";
        this.scorePercentage.twoStar = (twoStar / totalAccessCount * 100).toFixed(1) + "%";
        this.scorePercentage.threeStar = (threeStar / totalAccessCount * 100).toFixed(1) + "%";
        this.scorePercentage.fourStar = (fourStar / totalAccessCount * 100).toFixed(1) + "%";
        this.scorePercentage.fiveStar = (fiveStar / totalAccessCount * 100).toFixed(1) + "%";
        // console.log(oneStar, twoStar, threeStar, fourStar, fiveStar, totalAccessCount)
        this.scorePercentage.scoreStatic = parseFloat((((oneStar / totalAccessCount * 100).toFixed(1) / 100 * 1 +
          (twoStar / totalAccessCount * 100) / 100 * 2 +
          (threeStar / totalAccessCount * 100) / 100 * 3 +
          (fourStar / totalAccessCount * 100) / 100 * 4 +
          (fiveStar / totalAccessCount * 100) / 100 * 5).toFixed(1)))
        let scope = 2.5;
        document.getElementById("oneStar").style.width = this.scorePercentage.oneStar.substring(0, this.scorePercentage.oneStar.indexOf("%", 0)) * scope + "px";
        document.getElementById("twoStar").style.width = this.scorePercentage.twoStar.substring(0, this.scorePercentage.twoStar.indexOf("%", 0)) * scope + "px";
        document.getElementById("threeStar").style.width = this.scorePercentage.threeStar.substring(0, this.scorePercentage.threeStar.indexOf("%", 0)) * scope + "px";
        document.getElementById("fourStar").style.width = this.scorePercentage.fourStar.substring(0, this.scorePercentage.fourStar.indexOf("%", 0)) * scope + "px";
        document.getElementById("fiveStar").style.width = this.scorePercentage.fiveStar.substring(0, this.scorePercentage.fiveStar.indexOf("%", 0)) * scope + "px";
      })
    },
    //用户打分
    scoreChange(value) {
      if (this.isLogin) {
        this.userScore = value;
        let scoreJson = {
          userId: this.userId,
          articleId: this.blogId,
          scoreNum: this.userScore
        }
        request({
          url: '/blog/saveScore',
          method: 'post',
          params: {
            scoreJson: scoreJson,
          }
        }).then(response => {
          // console.log(response)
          if (response.data.flag) {
            this.getBlogById();
          }
          this.isEdit = false;
        })
      } else {
        this.$message.error("请先登录后打分")
        this.userScore = 0;
      }
    },
    //用户是否评分
    isScore() {
      if (this.userId)
        request({
          url: '/blog/isScore',
          method: 'get',
          params: {
            userId: this.userId,
            articleId: this.blogId,
          }
        }).then(response => {
          // console.log(response)
          if (response.data.flag && response.data.data.isScore) {
            //用户评论过
            this.isEdit = false;

            this.userScore = response.data.data.scoreNum;
          } else {
            //没有评论
            this.isEdit = true;
          }
        }).catch(failure => {
          //没有评论
          this.isEdit = true;
        })
    },

    //评论部分
    handTime(data) {//处理时间 以多少天之前、多少秒之前...展示
      let currentTime = new Date().getTime();
      let recentTime = new Date(
        data.substr(0, 4),
        parseInt(data.substr(5, 2)) - 1,
        data.substr(8, 2),
        data.substr(11, 2),
        data.substr(14, 2),
        data.substr(17, 2),
      ).getTime();

      let time = currentTime - recentTime;
      let seconds = parseInt(time / 1000 + "");//秒
      let targetTime = null;
      if (seconds >= 60 * 60 * 24 * 30 * 12) {//31,104,000
        targetTime = parseInt(seconds / (60 * 60 * 24 * 30 * 12)) + "年前";
      } else if (seconds >= 60 * 60 * 24 * 30) {//2,592,000
        targetTime = parseInt(seconds / (60 * 60 * 24 * 30)) + "月前";
      } else if (seconds >= 60 * 60 * 24) {//86,400
        targetTime = parseInt(seconds / (60 * 60 * 24)) + "天前";
      } else if (seconds >= 60 * 60) {//3,600
        targetTime = parseInt(seconds / (60 * 60)) + "小时前";
      } else if (seconds >= 60) {//60
        targetTime = parseInt(seconds / 60) + "分前";
      } else {
        targetTime = seconds + "秒前";
      }
      return targetTime;
    },
    getMes() {//获取留言信息总数据
      let that = this;
      request({
        url: "/Leave/findCmt",
        method: 'get',
        params: {
          begin: that.currentPage,
          articleId: that.blogId
        }
      }).then(response => {
        let data = response.data.data;
        for (let i = 0; i < data.length; i++) {
          data[i].mainHeadPortrait = base_url + '/getImage/' + data[i].mainHeadPortrait;
          data[i].createTime = this.handTime(data[i].createTime);
          for (let j = 0; j < data[i].articleUser.length; j++) {
            // console.log(data[i].articleUser[j])
            data[i].articleUser[j].headPortrait1 = base_url + '/getImage/' + data[i].articleUser[j].headPortrait1;
            data[i].articleUser[j].headPortrait2 = base_url + '/getImage/' + data[i].articleUser[j].headPortrait2;
            data[i].articleUser[j].replyTime = this.handTime(data[i].articleUser[j].replyTime);
            data[i].articleUser[j].mainId = data[i].articleUser[j].mainId + "";
          }
          data[i].articleUser.lengths = data[i].articleUser.length;
        }
        that.Comment = data;
        this.getCount();
      });
    },
    //提交评论
    send(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isLogin) {
            let that = this;
            request({
              url: '/Leave/leaveCmt',
              method: 'post',
              params: {
                userId: that.userId,
                articleId: that.blogId,
                content: that.ruleForm.content
              }
            }).then(response => {
              if (response.data.flag) {
                this.$message({
                  type: 'success',
                  message: '评论成功'
                });
                this.$refs['ruleForm'].resetFields();
                this.getMes();
              } else {
                this.$notify.error({
                  type: 'error',
                  message: '评论失败'
                });
              }
            })
          } else {
            this.$message({
              type: 'error',
              message: '请先登陆'
            });
          }
        }
      })

    },
    reply(id, mainId, replyId, repliedId, formName) {
      this.$refs[formName][0].validate((valid) => {
        if (valid) {
          let that = this;
          if (this.isLogin !== null) {
            request({
              url: '/Leave/replyCmt',
              method: 'post',
              params: {
                id: id,
                mainId: mainId,
                replyId: replyId,
                repliedId: repliedId,
                replyContent: this.ruleForm.checkText
              }
            }).then(response => {
              if (response.data.flag) {
                that.getMes();
                this.$message({
                  type: 'success',
                  message: '回复成功'
                });
                this.BigActiveId = -1;
                this.SmallActiveId = -1;
              } else {
                this.$notify.error({
                  type: 'error',
                  message: '回复失败'
                });
              }
            }).catch(e => {
              // console.log(e)
            })
          } else {
            this.$notify.error({
              type: 'error',
              message: '请先登录账号'
            });
          }
        }
      })

    },
    //根评论删除
    del(id, num) {
      if (this.isLogin !== null) {
        request({
          url: '/Leave/deleteCmt',
          method: 'post',
          params: {
            id: id,
            num: num
          }
        }).then(response => {
          if (response.data.flag) {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            if (this.Comment.length === 1 && this.currentPage !== 1) {
              this.currentPage = this.currentPage - 1;

            }
            this.getMes();
          } else {
            this.$notify.error({
              type: 'error',
              message: '删除失败'
            });
          }
        })
      } else {
        this.$notify.error({
          message: '请先登录账号'
        });
      }
    },
    big(id) {
      this.BigActiveId = id;
      this.SmallActiveId = -1;

    },
    small(id) {
      this.SmallActiveId = id;
      this.BigActiveId = -1;
    },
    //每次进来页面的时候,对应博客访问数+1
    addBlogViewCount() {
      request({
        url: 'blog/addBlogViewCount/' + this.blogId,
        method: 'post',
      })
    },
    change(value) {//实现翻页效果
      this.currentPage = value;
      this.getMes();
    },
    getCount() {
      let that = this;
      request({
        url: '/Leave/findAllCmt',
        method: 'post',
        params: {
          articleId: that.blogId,
        }
      }).then(response => {
        this.totalCount = response.data;
      });
    }
  },
  //axios请求，在这里
  mounted() {
    let data = this.$route.params;
    if (data.blogId !== undefined) {
      this.blogId = data.blogId;
      window.sessionStorage.setItem("blogId", data.blogId);
    } else {
      this.blogId = window.sessionStorage.getItem("blogId");
    }
    let isLogin = window.localStorage.getItem("isLogin");
    let userId = window.localStorage.getItem("userId");
    if (isLogin !== '' && userId !== '') {
      this.isLogin = isLogin;
      this.userId = userId;
    }
    this.getBlogById();
    this.isScore();
    this.getMes();
    this.addBlogViewCount();
  },

}
</script>

<style scoped>
.content {
  border-radius: 8px;
  width: 1000px;
  height: max-content;
  padding-bottom: 20px;
  background-color: rgb(255, 255, 255);
  margin: 30px auto 20px auto;
}

.round {
  border-radius: 50%;
}

.title {
  padding-top: 20px;
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  height: 40px;
  border-bottom: 1px solid #cccccc;
}

.comments {
  margin-top: 50px;
  box-shadow: 0 1px 2px 0 rgb(34 36 38);
  border: 1px solid rgba(34, 36, 38, .15);
  border-top: 2px solid #409EFF;
  text-align: left;
}

.reply {
  margin-left: 40px;
  font-size: 12px;
  color: rgba(0, 0, 0, .5);
}

.delete {
  margin-left: 10px;
  font-size: 12px;
  color: rgba(0, 0, 0, .5);
}

.reply:hover {
  color: rgba(0, 0, 0, 1);
  cursor: pointer;
}

.delete:hover {
  color: rgba(0, 0, 0, 1);
  cursor: pointer;
}

.header {
  font-family: Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-weight: 700;
  font-size: 1.28571429rem;
  color: rgba(0, 0, 0, .87);
}


.commet-reply {
  position: relative;
  margin-left: 40px;
}

.fewbody {
  padding-left: 10px;
  border: 1px solid white;
  width: 900px;
  height: max-content;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleContent.vue